<nz-layout class="rounded">
    <nz-content>
        <div class="p-4 flex justify-between">
            <div class="flex gap-3 items-center">
                <button nz-button nzType="default" (click)="close()">Close</button>
                <button nz-button nzType="primary" (click)="closeAndUpdate()">Close + Mark Reviewed</button>
                <nz-select
                    [ngModel]="consultation.status"
                    (ngModelChange)="updateStatus($event)"
                    nzPlaceHolder="Status"
                    style="min-width: 200px"
                >
                    <nz-option
                        *ngFor="let status of statuses"
                        [nzValue]="status.name"
                        [nzLabel]="status.label"
                    ></nz-option>
                </nz-select>
            </div>
            <div>
                <nz-tag *ngIf="consultation.internal" [nzColor]="'cyan'"
                    >Internal</nz-tag
                >
            </div>
            <button
                nz-button
                nzType="primary"
                nzShape="round"
                (click)="openCreateConsultationDrawer()"
            >
                Edit
            </button>
        </div>

        <ng-container *ngFor="let model of evaluatedQuestionModels">
            <p class="scoreText">
                {{ model.label }}: {{ getScore(model.field) }}
            </p>
        </ng-container>

        <div class="p-4">
            <portals-emr-notes-list
                [consultation]="consultation"
                label="Notes"
            ></portals-emr-notes-list>
        </div>

            <consultation-viewer
                [questions]="questions"
                [data]="data"
                [brand]="consultation.customer['organization']"
            />

        <div *ngIf="hasPathwaiSubmission" class="pathwai-viewer-container">
            <div *ngIf="pathwaiTokenError" class="pathwai-error">
                <nz-alert
                    nzType="warning"
                    [nzMessage]="pathwaiTokenError"
                    nzShowIcon
                ></nz-alert>
            </div>
            <div *ngIf="!pathwaiToken && !pathwaiTokenError" class="pathwai-loading">
                <nz-spin nzTip="Loading submission..."></nz-spin>
            </div>
            <pathwai-submission-viewer
                *ngIf="pathwaiToken && !pathwaiTokenError"
                [attr.token]="pathwaiToken"
            ></pathwai-submission-viewer>
        </div>

        <div *ngIf="consultation.type === 'acne'">
            <p class="linkText">
                URL: <a [href]="acneUrl" target="_blank">{{ acneUrl }}</a>
            </p>
        </div>
    </nz-content>

    <div *ngIf="consultation.statusHistory?.length">
        <nz-divider nzText="Status History" nzOrientation="left"></nz-divider>
        <nz-timeline nzMode="left">
            <nz-timeline-item
                [nzLabel]="consultation.createdAt | date : 'MMM d, y, h:mm a'"
            >
                <nz-tag
                    >{{
                        consultationStatuses[
                            consultation.statusHistory[0].prevStatus
                        ]
                    }}
                </nz-tag>
            </nz-timeline-item>
            <nz-timeline-item
                *ngFor="let history of consultation.statusHistory"
                [nzLabel]="history.updatedAt | date : 'MMM d, y, h:mm a'"
            >
                <nz-tag>{{ consultationStatuses[history.newStatus] }} </nz-tag>
                <ng-container
                    *ngTemplateOutlet="
                        userName;
                        context: {
                            $implicit: history.userId | userDetails | async
                        }
                    "
                    >
                </ng-container>
            </nz-timeline-item>
        </nz-timeline>
    </div>
    <ng-template #userName let-user>
        <nz-tag>{{ user?.firstName }} {{ user?.lastName }}</nz-tag>
    </ng-template>
    <!-- <nz-footer class="boxed">
        <div class="controls-bar">
            <button nz-button nzType="primary" style="float: left;" (click)="save()" disabled>Save</button>
            <button nz-button nzType="primary" style="float: right;" (click)="createRx()">Create RX</button>
        </div>
    </nz-footer> -->
</nz-layout>
